import languages from "@/data/languages.json";
import { hasSameBaseLanguage } from "@/lib/learning-mode";

const languageEntries = Object.entries(languages);

export function getTranslationLanguageName(code: string): string {
  return languageEntries.find(([, value]) => value === code)?.[0] || "";
}

export function getTranslationLanguageCodeFromName(name?: string): string | undefined {
  const normalized = name?.trim().toLowerCase();
  if (!normalized) return undefined;
  if (normalized === "english") return "en-US";
  if (normalized === "spanish") return "es-ES";
  return languageEntries.find(([value]) => value.toLowerCase() === normalized)?.[1];
}

export function resolveTranslationLanguageCode({
  targetLanguageCode,
  preferredLanguageCode,
  guidedInstructionLanguageCode,
}: {
  targetLanguageCode: string;
  preferredLanguageCode?: string | null;
  guidedInstructionLanguageCode?: string | null;
}): string {
  const candidates = [preferredLanguageCode, guidedInstructionLanguageCode, "en-US", "es-ES"];
  return (
    candidates.find(
      (code): code is string =>
        Boolean(code && getTranslationLanguageName(code)) &&
        !hasSameBaseLanguage(targetLanguageCode, code)
    ) || ""
  );
}
